module.exports = new __parcel__URL__("73091277-1.c533d2ac.png").toString();